import type { TprReferralAuthorizationOutput } from "@/src/lib/workflows/steps/step-outputs";

export function tprReferralAuthNeedsPendingUpload(
  authorization: TprReferralAuthorizationOutput | null | undefined
): boolean {
  if (!authorization) return false;
  if (authorization.outcome === "needs_pending_request") return true;

  return authorization.outcome === "created" && authorization.write === "authorization" && authorization.pending;
}

export function tprReferralAuthNeedsReview(authorization: TprReferralAuthorizationOutput | null | undefined): boolean {
  if (!authorization) return false;
  if (authorization.outcome === "needs_review") return true;

  return authorization.outcome === "not_needed" && authorization.reason === "requirements_unresolved";
}
